import { useReactiveVar } from '@apollo/client'
import { Hidden, Typography, IconButton } from '@material-ui/core'
import DeleteRoundedIcon from '@material-ui/icons/DeleteRounded'

import { jobsListVar, updateJobStatus } from '../../cache/jobs'
import { getTranslate } from '../../localization'
import { Status } from '../../types/BulkAccessManagement'
import JobsRow from './JobsRow'
import useStyles from './styles/table.styles'

export const JobsTable = () => {
  const jobs = useReactiveVar(jobsListVar)
  const classes = useStyles()

  const handleDeleteAllJobs = () => {
    const newjobs = jobs.filter((item) => !item.status.includes('Finished'))
    jobsListVar(newjobs)
    localStorage.setItem('jobs', JSON.stringify(newjobs))
  }

  return (
    <div className={classes.root}>
      {jobs.length > 0 ? (
        <div className={classes.tableHead}>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Track ID')}
            </Typography>
          </div>
          <Hidden smDown>
            <div>
              <Typography className={classes.tableHeader} variant="h4">
                {getTranslate('Creation Date')}
              </Typography>
            </div>
          </Hidden>
          <div>
            <Typography className={classes.tableHeader} variant="h4">
              {getTranslate('Status')}
            </Typography>
          </div>
          <Hidden smDown>
            <div>
              <IconButton onClick={() => handleDeleteAllJobs()}>
                <DeleteRoundedIcon />
              </IconButton>
            </div>
          </Hidden>
        </div>
      ) : (
        <div>
          <Typography variant="h4">
            {getTranslate('There are no active jobs for you')}
          </Typography>
        </div>
      )}
      {jobs
        .filter((item) => !!item.trackID)
        .map((singleJob, jobIndex) => {
          return (
            <JobsRow
              key={singleJob.trackID}
              data={singleJob}
              onChangeJobStatus={(status: Status) =>
                updateJobStatus(jobIndex, status)
              }
              jobIndex={jobIndex}
            />
          )
        })}
    </div>
  )
}
